module.exports = __webpack_public_path__ + "img/traveller-active.fa54ab6f.svg";